import { getIdpDisclaimer } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { IdpDisclaimerT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Fetch the IDP disclaimer text for the authenticated user.
 */
export async function fetchIdpDisclaimer(signal?: AbortSignal): Promise<IdpDisclaimerT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getIdpDisclaimer(config);
  const data = lotusHealthZod.getIdpDisclaimerResponse.parse(response.data) as IdpDisclaimerT;

  logger.info('dosespot.idp.fetchDisclaimer', {
    source: 'entities/dosespot-idp/api',
    disclaimerId: data.IdpDisclaimerId,
  });

  return data;
}
